module.exports = __webpack_public_path__ + "static/media/checking-production-bottled-refined-sunflower-oil-food-factory-production-line-min.84c9ee5a.jpg";